module.exports = __webpack_public_path__ + "static/brain-9a62f8b0690b4dbd2111f9ef675533a2.png";